// extracted by mini-css-extract-plugin
export default {"root":"LogInPage_root__qI9UR","img":"LogInPage_img__qPzPF","content":"LogInPage_content__grpPF","btns":"LogInPage_btns__Babfy","uiFirebase":"LogInPage_uiFirebase__nZ7J2"};